/* eslint-disable no-unused-vars */
// ESLint is showing errors for the DATA_TYPE enum as unused variables in this file

const getSymbolFromCurrency = (currencyCode: string) => {
  return currencyCode;
};
const NaNValue = 'N/A';

enum DATA_TYPE {
  NUMBER = 'NUMBER',
  FLOAT = 'FLOAT',
  INT = 'INT',
  VARCHAR = 'VARCHAR(MAX)',
  TEXT = 'TEXT',
}

export const formatByDataType = (
  n: number,
  dataType: string = DATA_TYPE.NUMBER,
  currencyCode: string | undefined = undefined,
  maximumFractionDigits: number = 0,
  minimumFractionDigits: number = 0,
): string => {
  switch (dataType.toUpperCase()) {
    case DATA_TYPE.NUMBER:
    case DATA_TYPE.FLOAT:
      return formatNumber(n, undefined, currencyCode);
    case DATA_TYPE.INT:
      return formatNumber(n, {
        maximumFractionDigits,
        minimumFractionDigits,
      });
  }
  return n?.toString();
};

export const formatNumber = (
  n?: number,
  options: Intl.NumberFormatOptions = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
  currencyCode: string | undefined = undefined,
): string => {
  if (n === undefined || n === null) return NaNValue;
  if (currencyCode !== undefined) {
    const currency = getSymbolFromCurrency(currencyCode);
    const sign = n < 0 ? '-' : '';
    return `${sign}${currency}${Math.abs(n).toLocaleString(undefined, options)}`;
  }
  return n.toLocaleString(undefined, options);
};

export interface RangeFormat {
  threshold: number;
  divider: number;
  suffix: string;
  options: { maximumFractionDigits: number };
}
const ranges: RangeFormat[] = [
  {
    threshold: 1e9,
    divider: 1e9,
    suffix: 'B',
    options: { maximumFractionDigits: 1 },
  },
  {
    threshold: 1e6,
    divider: 1e6,
    suffix: 'M',
    options: { maximumFractionDigits: 1 },
  },
  {
    threshold: 1e3,
    divider: 1e3,
    suffix: 'k',
    options: { maximumFractionDigits: 1 },
  },
];

export const findBigNumberFormat = (n?: number) => {
  if (n === undefined) return undefined;
  for (let i = 0; i < ranges.length; i++) {
    const r = ranges[i];
    if (Math.abs(n) >= r.threshold) {
      return r;
    }
  }
};

export const formatBigNumber = (
  n?: number,
  currencyCode: string | undefined = undefined,
  defaultOptions: Intl.NumberFormatOptions = { maximumFractionDigits: 0 },
  rangeFormat?: RangeFormat,
) => {
  if (n === undefined) return NaNValue;

  const r = rangeFormat ?? findBigNumberFormat(n);

  if (r) {
    const divided = n / r.divider;
    const formatted = formatNumber(divided, { ...r.options }, currencyCode);
    return formatted + r.suffix;
  }

  return formatNumber(n, defaultOptions, currencyCode);
};

export const formatPercNumber = (n?: number) => {
  if (n === undefined) return NaNValue;

  return formatNumber(n, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  });
};
